import useAlert from "../../../../../../../use/useAlert";
import {useRef} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Box from "@mui/material/Box";
import {Button, TextField} from "@mui/material";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {CheckCircle} from "@mui/icons-material";
import NotifyJustifyAdditionalShifting from "./NotifyJustifyAdditionalShifting";
import isNull from "../../../../../../../mixin/isNull";

const ARRAY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];

export default function ({next, additionalShiftingQuantity}) {
    const alert = useAlert();
    const shiftingResult = useRef({});

    const nextStep = () => {
        let missJustification = false;

        for (const key of ARRAY) {
            if (key > additionalShiftingQuantity) {
                break;
            }

            if (isNull(shiftingResult.current[key]) || shiftingResult.current[key].length === 0) {
                missJustification = true;
                break;
            }
        }

        if (missJustification) {
            alert.warning("Veuillez compléter le compte rendu");
            return;
        }

        next(shiftingResult.current);
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyJustifyAdditionalShifting/>
                </Box>

                {
                    ARRAY.map((item) => {
                        if (item <= additionalShiftingQuantity) {
                            return (
                                <Box key={item} mt={2} px={2}>
                                    <TextField
                                        label={`Justifiez le déplacement supplémentaire ${item}`}
                                        fullWidth={true}
                                        multiline={true}
                                        minRows={2}
                                        onChange={e => {
                                            shiftingResult.current[item] = e.target.value;
                                        }}
                                        data-test="input-justify-additional-shifting"
                                    />
                                </Box>
                            )
                        }

                        return null;
                    })
                }
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}